import { render } from "./CouponCreateUpdateModal.vue?vue&type=template&id=22ce1946&scoped=true"
import script from "./CouponCreateUpdateModal.vue?vue&type=script&lang=js"
export * from "./CouponCreateUpdateModal.vue?vue&type=script&lang=js"

import "./CouponCreateUpdateModal.vue?vue&type=style&index=0&id=22ce1946&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ce1946"]])

export default __exports__